import * as React from 'react';
import ReactDOM from 'react-dom';
import uniqBy from 'lodash/uniqBy';
import Toggle from 'react-toggled';
import makeComponentTrashable from 'trashable-react';
import AudiotrackOutlinedIcon from '@material-ui/icons/AudiotrackOutlined';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Snackbar from '@material-ui/core/Snackbar';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import { conversations } from '../../services/api/scribe';
class ScribeSpeechTrainingSelector extends React.Component {
    constructor(props) {
        super(props);
        this.clearToastTimeout = null;
        this.state = {};
    }
    startTrainingFile(title) {
        const { registerPromise } = this.props;
        const fetchTraining = registerPromise(conversations.updateTrainingConversations({ title }));
        fetchTraining
            .then((res) => {
            this.setState({ toast: title });
            this.scheduleTimeout();
        })
            .catch((err) => {
            this.setState({ toast: 'error' });
            this.scheduleTimeout();
        });
    }
    scheduleTimeout() {
        this.clearToastTimeout = setTimeout(() => {
            this.setState({ toast: undefined });
        }, 10000);
    }
    componentWillUnmount() {
        if (this.clearToastTimeout)
            clearTimeout(this.clearToastTimeout);
    }
    render() {
        const { classes, conversationRequested, conversationStarted, openWebsocketCount } = this.props;
        if (localStorage.getItem('scribeBackendUrl') === 'https://scribe.ava.me')
            return null;
        if (conversationRequested || conversationStarted || openWebsocketCount === 0) {
            return null;
        }
        const { scribeTrainings } = this.props;
        const { toast } = this.state;
        return (React.createElement(Toggle, null, ({ on, getTogglerProps }) => (React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
            } },
            React.createElement(ListItem, Object.assign({ button: true }, getTogglerProps()),
                React.createElement(ListItemIcon, null,
                    React.createElement(AudiotrackOutlinedIcon, null)),
                React.createElement(ListItemText, { classes: { primary: classes.listItemText }, primary: "Training Files" }),
                React.createElement(ListItemIcon, null, (!on && React.createElement(ExpandMoreOutlinedIcon, null)) || React.createElement(ExpandLessOutlinedIcon, null))),
            React.createElement(Collapse, { in: on, timeout: "auto", unmountOnExit: true },
                React.createElement(List, null, scribeTrainings &&
                    uniqBy(scribeTrainings, (t) => t.title).map((file) => (React.createElement(ListItem, { button: true, key: file.title },
                        React.createElement(ListItemText, { classes: { primary: classes.listItemText }, onClick: () => {
                                this.startTrainingFile(file.title);
                            }, primary: file.desc })))))),
            document.body
                ? ReactDOM.createPortal(
                // eslint-disable-next-line react/jsx-indent
                React.createElement(Snackbar, { anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }, open: !!toast, onClose: () => {
                        this.setState({
                            toast: undefined,
                        });
                    }, message: 
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    React.createElement("span", { style: {
                            color: toast === 'error' ? 'red' : undefined,
                        } }, toast === 'error' ? 'Something went wrong!' : `${toast || ''} is starting`) }), document.body)
                : null))));
    }
}
export default makeComponentTrashable(ScribeSpeechTrainingSelector);
